import React from "react";
import * as styles from "./../base.scss";
import Price from "../../Price";
const ProductListItemPrice = (props) => {
    if (!props.isLoggedIn ||
        props.isSupplierSalesman ||
        !props.selectedVariant ||
        !props.selectedVariant.price) {
        return null;
    }
    const isInCampaign = props.productIsInCampaign && props.price.current < props.price.original;
    return isInCampaign ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.product_price__campaign },
            React.createElement(PriceDefault, Object.assign({}, props))),
        React.createElement("div", { className: styles.product_price__original },
            React.createElement(PriceDefault, Object.assign({}, props, { showOriginal: true }))))) : (React.createElement(PriceDefault, Object.assign({}, props)));
};
const PriceDefault = ({ price, showOriginal }) => {
    return (React.createElement(Price, Object.assign({ size: "small" }, price, { 
        //eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        //@ts-ignore
        comparison: null, current: showOriginal ? price.original : price.current, noPriceClassName: styles.noPrice })));
};
export default ProductListItemPrice;
